// Validation functions
import { handleGetClientSessionInfo } from './ClientServiceTS';

function decimalValidationAll(array, property) {
  let valid = true;
  const decimalRex = /^[0-9]+(.[0-9]{1,2})?$/;
  array.forEach((obj) => {
    if (!decimalRex.test(obj[property])) {
      valid = false;
    }
  });
  return valid;
}

async function checkClientSession({ accountId, accountType }) {
  return handleGetClientSessionInfo()
    .then((sessionData) => {
      if (!sessionData) {
        return { error: 'no response from api' };
      }
      if (sessionData.error) {
        return sessionData;
      }
      const sessionAccountType = sessionData.accountType;

      return {
        sessionMatch:
          accountId?.toString() === sessionData?.id?.toString() &&
          accountType === sessionData?.accountType,
        sessionClientId: sessionData[sessionAccountType].id,
        sessionClientName: sessionData[sessionAccountType].name,
      };
    })
    .catch(() => {
      return { error: 'Unknown Error' };
    });
}
/**
 * @typedef {{capAmount: string,capPeriod: string, paced: 0|1}[]} Caps
 * @param {Caps} capBudgets
 * @param {string | null | undefined} endDate
 * @param {boolean | undefined} isAdManager
 * @returns
 */
function validateCapBudget(capBudgets, endDate = null, isAdManager = false) {
  // Basic validation: non empty and positive numeric
  const basicValidation =
    capBudgets.length > 0 &&
    capBudgets.length ===
      capBudgets.filter((cap) => !Number.isNaN(Number(cap.capAmount)) && Number(cap.capAmount) > 0)
        .length;
  if (!basicValidation) {
    return {
      state: 'error',
      message: 'Value must be numeric and greater than 0',
    };
  }
  // check for max 2 decimals
  const decimalValid = decimalValidationAll(capBudgets, 'capAmount');
  if (!decimalValid) {
    return {
      state: 'error',
      message: 'Values with decimals must be to maximum 2 decimal places',
    };
  }
  // AdManager is doing its separate validation of total caps to improve UX
  if (!isAdManager) {
    // Paced total budget requires a campaign end date
    const totalCap = capBudgets.filter((cap) => cap.capPeriod === 'O' && cap.paced).length > 0;
    const noEndDate = endDate === null || endDate === '';
    const pacedValid = !(totalCap && noEndDate);
    if (!pacedValid) {
      return {
        state: 'error',
        message: 'Paced total budget requires a campaign end date',
      };
    }
  }
  const dailyBudgets = capBudgets.filter((cap) => cap.capPeriod === 'D').length;
  const weeklyBudgets = capBudgets.filter((cap) => cap.capPeriod === 'W').length;
  const monthlyBudgets = capBudgets.filter((cap) => cap.capPeriod === 'M').length;
  const totalBudgets = capBudgets.filter((cap) => cap.capPeriod === 'O').length;
  if (dailyBudgets > 1 || weeklyBudgets > 1 || monthlyBudgets > 1 || totalBudgets > 1) {
    return {
      state: 'error',
      message: 'Budgets are limited to only one daily, weekly, monthly and total caps',
    };
  }
  return {
    state: 'success',
    message: '',
  };
}

export default {
  checkClientSession,
  validateCapBudget,
};
